
export interface PageContext {
  path: string,
  referrer: string,
  search: string,
  title: string,
  url: string
}

/**
* Get the Page Context data
*
* @return {PageContext}
*/
export function getPageContext(): PageContext {
  return {  
    path: location.pathname,
    referrer: document.referrer,
    search: location.search,
    title: document.title,
    url: location.href
  };
}
